<template>
  <div v-if="companyappointment.status !== 'retired'" class="table-condendsed">
    <table class="table table-striped table-condensed">
      <tbody>
        <tr>
          <th scope="row" style="width: 30%">Company:</th>
          <th scope="row">{{ isEmptyMessage(report.companyoverview.company_name) }}</th>
        </tr>
        <tr>
          <th scope="row">Function:</th>
          <td>{{ isEmptyMessage(companyappointment.official_role) }}</td>
        </tr>
        <tr>
          <th scope="row">Position:</th>
          <td>{{ isEmptyMessage(companyappointment.position) }}</td>
        </tr>
        <tr>
          <th scope="row">Status:</th>
          <td>{{ isEmptyMessage(companyappointment.status) }}</td>
        </tr>
        <tr>
          <th scope="row">Appointment Date:</th>
          <td>{{ isEmptyMessage(formatDate(companyappointment.start_date)) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';

export default {
  mixins: [toolsMixin],
  props: ['companyappointment', 'report'],
};
</script>
